<ndt-two-column-list-layout>
   <ndt-department-register two-column-list-content-layout-list></ndt-department-register>
   <ndt-department-detail class="department-detail-column"></ndt-department-detail>
</ndt-two-column-list-layout>
